import { useSessionStorageState } from "ahooks";

const useLoginSession = () => {
	const [isLoginBySession, setIsLoginBySession] = useSessionStorageState("is_login_by_session", {
		defaultValue: false,
	});


	function postMessage(message: string | object) {
		if (window.ReactNativeWebView) {
			let str = typeof message === "object" ? JSON.stringify(message) : message;
			window.ReactNativeWebView.postMessage(str);
		}
	}

	function postSuccess() {
		postMessage({
			status: "success",
		});
	}

	function postErrorMessage(message: string) {
		postMessage({
			status: "error",
			message: message,
		});
	}



	return { isLoginBySession, setIsLoginBySession, postMessage, postSuccess, postErrorMessage };
}

export default useLoginSession;